export const FETCH_PUBLIC_ORGANIZATIONS_REQUEST = 'FETCH_PUBLIC_ORGANIZATIONS_REQUEST';
export const FETCH_PUBLIC_ORGANIZATIONS_SUCCESS = 'FETCH_PUBLIC_ORGANIZATIONS_SUCCESS';
export const FETCH_PUBLIC_ORGANIZATIONS_FAILED = 'FETCH_PUBLIC_ORGANIZATIONS_FAILED';

export const FETCH_ORGANIZATION_BY_ID_REQUEST = 'FETCH_ORGANIZATION_BY_ID_REQUEST';
export const FETCH_ORGANIZATION_BY_ID_SUCCESS = 'FETCH_ORGANIZATION_BY_ID_SUCCESS';
export const FETCH_ORGANIZATION_BY_ID_FAILED = 'FETCH_ORGANIZATION_BY_ID_FAILED';

export const FETCH_UPDATE_ORGANIZATION_REQUEST = 'FETCH_UPDATE_ORGANIZATION_REQUEST';
export const FETCH_UPDATE_ORGANIZATION_SUCCESS = 'FETCH_UPDATE_ORGANIZATION_SUCCESS';
export const FETCH_UPDATE_ORGANIZATION_FAILED = 'FETCH_UPDATE_ORGANIZATION_FAILED';

export const UFETCH_PLOAD_ORGANIZATION_LOGO_REQUEST = 'UFETCH_PLOAD_ORGANIZATION_LOGO_REQUEST';
export const UFETCH_PLOAD_ORGANIZATION_LOGO_SUCCESS = 'UFETCH_PLOAD_ORGANIZATION_LOGO_SUCCESS';
export const FETCH_UPLOAD_ORGANIZATION_LOGO_FAILED = 'FETCH_UPLOAD_ORGANIZATION_LOGO_FAILED';

export const FETCH_AVAILABLES_BROKERS_REQUEST = 'FETCH_AVAILABLES_BROKERS_REQUEST';
export const FETCH_AVAILABLES_BROKERS_SUCCESS = 'FETCH_AVAILABLES_BROKERS_SUCCESS';
export const FETCH_AVAILABLES_BROKERS_FAILED = 'FETCH_AVAILABLES_BROKERS_FAILED';

export const RESET_UPDATE_ORGANIZATION_SUCCESS = 'RESET_UPDATE_ORGANIZATION_SUCCESS';

export const RESET_UPLOAD_ORGANIZATION_LOGO_SUCCESS = 'RESET_UPLOAD_ORGANIZATION_LOGO_SUCCESS';

export const FETCH_CREATE_PAYMENT_ACCOUNT_REQUEST = 'FETCH_CREATE_PAYMENT_ACCOUNT_REQUEST';
export const FETCH_CREATE_PAYMENT_ACCOUNT_SUCCESS = 'FETCH_CREATE_PAYMENT_ACCOUNT_SUCCESS';
export const FETCH_CREATE_PAYMENT_ACCOUNT_FAILED = 'FETCH_CREATE_PAYMENT_ACCOUNT_FAILED';

export const FETCH_LINK_PAYMENT_ACCOUNT_REQUEST = 'FETCH_LINK_PAYMENT_ACCOUNT_REQUEST';
export const FETCH_LINK_PAYMENT_ACCOUNT_SUCCESS = 'FETCH_LINK_PAYMENT_ACCOUNT_SUCCESS';
export const FETCH_LINK_PAYMENT_ACCOUNT_FAILED = 'FETCH_LINK_PAYMENT_ACCOUNT_FAILED';

export const FETCH_PAYMENT_ONBOARD_REQUEST = 'FETCH_PAYMENT_ONBOARD_REQUEST';
export const FETCH_PAYMENT_ONBOARD_SUCCESS = 'FETCH_PAYMENT_ONBOARD_SUCCESS';
export const FETCH_PAYMENT_ONBOARD_FAILED = 'FETCH_PAYMENT_ONBOARD_FAILED';

export const FETCH_ACCOUNT_DETAILS_REQUEST = 'FETCH_ACCOUNT_DETAILS_REQUEST';
export const FETCH_ACCOUNT_DETAILS_SUCCESS = 'FETCH_ACCOUNT_DETAILS_SUCCESS';
export const FETCH_ACCOUNT_DETAILS_FAILED = 'FETCH_ACCOUNT_DETAILS_FAILED';

export const FETCH_RESET_CREATE_ACCOUNT_ONBOARDING = 'FETCH_RESET_CREATE_ACCOUNT_ONBOARDING';

export const FETCH_DELETE_ORGANIZATION_TO_BROKERS_REQUEST =
  'FETCH_DELETE_ORGANIZATION_TO_BROKERS_REQUEST';
export const FETCH_DELETE_ORGANIZATION_TO_BROKERS_SUCCESS =
  'FETCH_DELETE_ORGANIZATION_TO_BROKERS_SUCCESS';
export const FETCH_DELETE_ORGANIZATION_TO_BROKERS_FAILED =
  'FETCH_DELETE_ORGANIZATION_TO_BROKERS_FAILED';

export const FETCH_EDIT_ORGANIZATION_TO_BROKERS_REQUEST =
  'FETCH_EDIT_ORGANIZATION_TO_BROKERS_REQUEST';
export const FETCH_EDIT_ORGANIZATION_TO_BROKERS_SUCCESS =
  'FETCH_EDIT_ORGANIZATION_TO_BROKERS_SUCCESS';
export const FETCH_EDIT_ORGANIZATION_TO_BROKERS_FAILED =
  'FETCH_EDIT_ORGANIZATION_TO_BROKERS_FAILED';

export const FETCH_ORGANIZATION_TO_BROKER_REQUEST = 'FETCH_ORGANIZATION_TO_BROKER_REQUEST';
export const FETCH_ORGANIZATION_TO_BROKER_SUCESS = 'FETCH_ORGANIZATION_TO_BROKER_SUCESS';
export const FETCH_ORGANIZATION_TO_BROKER_FAILED = 'FETCH_ORGANIZATION_TO_BROKER_FAILED';
export const RESET_ORGANIZATION_TO_BROKER = 'RESET_ORGANIZATION_TO_BROKER';

export const FETCH_BROKER_SCHEMA_REQUEST = 'FETCH_BROKER_SCHEMA_REQUEST';
export const FETCH_BROKER_SCHEMA_SUCCESS = 'FETCH_BROKER_SCHEMA_SUCCESS';
export const FETCH_BROKER_SCHEMA_FAILED = 'FETCH_BROKER_SCHEMA_FAILED';
export const FETCH_RESET_BROKER_SCHEMA = 'FETCH_RESET_BROKER_SCHEMA';
